import {
  getBottomBoundary,
  getLeftBoundary,
  getRightBoundary,
  getTopBoundary,
} from '@/lib/editor/floating-canvas-chrome-bounds'

/** Keeps a manually-placed toolbar of `width` px horizontally inside the live area. */
export function clampToLiveAreaX(v: number, width: number): number {
  return Math.max(getLeftBoundary(), Math.min(getRightBoundary() - width - 8, v))
}

/** Keeps a manually-placed toolbar of `height` px vertically inside the live area. */
export function clampToLiveAreaY(v: number, height: number): number {
  return Math.max(getTopBoundary(), Math.min(getBottomBoundary() - height - 8, v))
}
